import React from 'react';

import { Box, Paper, Typography, CircularProgress } from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';

import { formatLocalDateTime, formatSessionHeaderMessage } from '../utils';

export function SessionActivityPanel({ classes, selectedSession, activity, activityLoading }) {
	return (
		<Paper className={classes.activityPanel} elevation={0}>
			<Box className={classes.activityHeader}>
				<Box className={classes.activityHeaderRow}>
					<Typography variant="subtitle1" className={classes.activityTitle}>Session Activity</Typography>
				</Box>
				{selectedSession && (
					<Typography variant="caption" className={classes.sessionTimeLabel} display="block">
						{formatSessionHeaderMessage(selectedSession.accessedAt, selectedSession.endedAt)}
					</Typography>
				)}
			</Box>
			<Box className={classes.activityBody}>
				{activityLoading ? (
					<Box display="flex" justifyContent="center" alignItems="center" minHeight={120}><CircularProgress /></Box>
				) : (
					<div className={classes.timeline}>
						{activity.map((item, idx) => (
							<React.Fragment key={idx}>
								{item.type === 'sessionStart' && (
									<div className={`${classes.timelineItem} ${classes.timelineItemSuccess}`}>
										<div className={classes.timelineTimeCol}>{item.at != null ? formatLocalDateTime(item.at) : (item.time || '—')}</div>
										<div className={classes.timelineDotWrap}><span className={classes.timelineDot} /></div>
										<div className={classes.timelineNodeCol}>
											<Typography variant="body2" component="span" style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
												<CheckCircleIcon style={{ fontSize: 16 }} />
												{item.label}
											</Typography>
										</div>
									</div>
								)}
								{item.type === 'sessionEnd' && (
									<div className={`${classes.timelineItem} ${classes.timelineItemError}`}>
										<div className={classes.timelineTimeCol}>{item.at != null ? formatLocalDateTime(item.at) : (item.time || '—')}</div>
										<div className={classes.timelineDotWrap}><span className={classes.timelineDot} /></div>
										<div className={classes.timelineNodeCol}>
											<Typography variant="body2" component="span" style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
												<RadioButtonUncheckedIcon style={{ fontSize: 16 }} />
												{item.label}
											</Typography>
										</div>
									</div>
								)}
								{item.type === 'page' && (
									<div className={`${classes.timelineItem} ${classes.timelineItemPage}`}>
										<div className={classes.timelineTimeCol}>{item.at != null ? formatLocalDateTime(item.at) : (item.time || '\u00A0')}</div>
										<div className={classes.timelineDotWrap}><span className={classes.timelineDot} /></div>
										<div className={classes.timelineNodeCol}>
											<div className={classes.pageTag}>{item.label}</div>
											{/* {item.url ? ` (${item.url})` : ''} */}
											{item.documentId && (
												<div className={classes.documentTag}>Document: {item.documentId}</div>
											)}
											{item.actions && item.actions.map((action, i) => (
												<div key={i} className={classes.actionItem}>
													<span className={classes.dot} />
													{action}
												</div>
											))}
										</div>
									</div>
								)}
								{item.type === 'branch' && (
									<div className={`${classes.timelineItem} ${classes.timelineItemBranch}`}>
										<div className={classes.timelineTimeCol}>{'\u00A0'}</div>
										<div className={classes.timelineDotWrap}><span className={classes.timelineDot} /></div>
										<div className={classes.timelineNodeCol}>
											<div className={classes.timelineBranch}>
												<button type="button" className={classes.destartButton}>
													{item.label}
												</button>
												{item.actions && item.actions.map((action, i) => (
													<div key={i} className={classes.actionItem}>
														<span className={classes.dot} />
														{action}
													</div>
												))}
											</div>
										</div>
									</div>
								)}
							</React.Fragment>
						))}
					</div>
				)}
			</Box>
		</Paper>
	);
}
